import { render } from "./PageRegistrarAtendimento.vue?vue&type=template&id=fe71f8a8&scoped=true"
import script from "./PageRegistrarAtendimento.vue?vue&type=script&lang=js"
export * from "./PageRegistrarAtendimento.vue?vue&type=script&lang=js"

import "./PageRegistrarAtendimento.vue?vue&type=style&index=0&id=fe71f8a8&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe71f8a8"]])

export default __exports__